import React, { useEffect, useState } from 'react';
import { Link, Navigate, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { Loader2 } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

export default function AssetLinkPage() {
  const { token } = useParams();
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [failed, setFailed] = useState(false);
  const validToken = /^[A-Za-z0-9_-]{22}$/.test(token || '');
  useEffect(() => {
    if (loading || !user || !validToken) return;
    let active = true;
    setFailed(false);
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/asset-links/${encodeURIComponent(token)}`, { withCredentials: true })
      .then(({ data }) => { if (active) navigate(`/activos/${encodeURIComponent(data.asset_id)}`, { replace: true }); })
      .catch(() => { if (active) setFailed(true); });
    return () => { active = false; };
  }, [token, user, loading, navigate, validToken]);
  if (!loading && !user && validToken) return <Navigate to={`/login?redirect=${encodeURIComponent('/a/' + token)}`} replace />;
  return <main className="min-h-screen flex items-center justify-center p-6" style={{ background: 'var(--color-bg-primary)', color: 'var(--color-text-primary)' }} data-testid="asset-link-page">
    {failed || !validToken ? <div className="max-w-md space-y-4"><h1 className="text-lg font-semibold" data-testid="asset-link-error-title">Enlace no disponible</h1><p role="alert" className="text-sm" data-testid="asset-link-error">El activo no está disponible o no tienes permiso para verlo.</p><Link to="/activos" className="btn-secondary inline-flex" data-testid="asset-link-back">Volver a mis activos</Link></div> : <p className="flex items-center gap-3 text-sm" role="status" data-testid="asset-link-loading"><Loader2 className="w-5 h-5 animate-spin" />Comprobando acceso…</p>}
  </main>;
}